import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  text: {
    fontWeight: 'normal',
    fontSize: spacing(14),
    lineHeight: spacing(20),
  },
}))
